<template>
  <el-table
    class="mt-edit"
    v-loading="loading"
    v-bind="$attrs"
    v-on="$listeners"
    ref='mTable'
    border
    @row-click="clickFn"
    @cell-click="toEdit"
    @row-dblclick="dblclickFn"
    @header-dragend="changeHeaderWidth"
  >
    <slot>
    </slot>
  </el-table>
</template>

<script>
import Sortable from 'sortablejs';
import $ from 'jquery';

const _ = require('lodash');

export default {
  props: {
    parentCol: {
      type: Array,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      col: [],
      loading: false,
      nweWidth: 0,
      keyEvent: event => {
        const current = $('.cellFocus');
        const currentClass = current.attr('class');
        switch (event.keyCode) {
          case 37: // 左键
            if (currentClass.indexOf('el-table') !== -1) {
              if (current.prev().length === 0) return;
              current.prev().addClass('cellFocus cellActive');
              current.removeClass('cellFocus cellActive');
              current.prev().find('input').focus();
            }
            else {
              if (current.parent().prev().length === 0) return;
              current.parent().prev().addClass('cellFocus cellActive');
              current.removeClass('cellFocus cellActive');
              current.parent().prev().find('input').focus();
            }
            break;
          case 38: // 上键
            if (currentClass.indexOf('el-table') !== -1) {
              if (current.parent().prev().length === 0) return;
              current.removeClass('cellFocus cellActive');
              current.parent().prev().find('td').eq(current.index()).addClass('cellFocus cellActive');
              current.parent().prev().find('td').eq(current.index()).find('input').focus();
            }
            else {
              if (current.parent().parent().prev().length === 0) return;
              current.removeClass('cellActive cellActive');
              current.parent().parent().prev().find('td').eq(current.parent().index()).addClass('cellFocus cellActive');
              current.parent().parent().prev().find('td').eq(current.parent().index()).find('input').focus();
            }
            break;
          case 39: // 右键
            if (currentClass.indexOf('el-table') !== -1) {
              if (current.next().length === 0) return;
              current.next().addClass('cellFocus cellActive');
              current.removeClass('cellFocus cellActive');
              current.next().find('input').focus();
            }
            else {
              if (current.parent().next().length === 0) return;
              current.parent().next().addClass('cellFocus cellActive');
              current.removeClass('cellFocus cellActive');
              current.parent().next().find('input').focus();
            }
            break;
          case 40: // 下键
            if (currentClass.indexOf('el-table') !== -1) {
              current.removeClass('cellFocus cellActive');
              if (current.parent().next().length > 0) {
                current.parent().next().find('td').eq(current.index()).addClass('cellFocus cellActive');
                current.parent().next().find('td').eq(current.index()).find('input').focus();
              }
              else {
                this.$emit('addNewData', () => {
                  current.parent().next().find('td').eq(current.index()).addClass('cellFocus cellActive');
                  current.parent().next().find('td').eq(current.index()).find('input').focus();
                });
              }
            }
            else {
              current.removeClass('cellFocus cellActive');
              current.parent().parent().next().find('td').eq(current.parent().index()).addClass('cellFocus cellActive');
              current.parent().parent().next().find('td').eq(current.parent().index()).find('input').focus();
            }
            break;
          case 13:
            // current.addClass('cellActive');
            current.find('input').focus();
            break;
        }
      },
    };
  },
  mounted() {
    this.initTable();
    this.columnDrop();
    this.$nextTick(() => {
      // this.columnDrop2();
    });
  },
  methods: {
    initTable() {
      this.col = _.cloneDeep(this.parentCol);
    },
    // 列拖拽
    columnDrop() {
      const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
      new Sortable.create(wrapperTr, {
        filter: '.el-table-column--selection, .el-table__expand-column',
        animation: 180,
        onMove: (evt, originalEvent) => {
          if (originalEvent.target.querySelector('el-table-column--selection')
              || originalEvent.target.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.className.indexOf('el-checkbox__input') !== -1
              || originalEvent.target.parentNode.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.parentNode.parentNode.className.indexOf('el-table-column--selection') !== -1
              || originalEvent.target.parentNode.className.indexOf('el-checkbox__input') !== -1) {
            return false;
          }
        },
        onEnd: ({ newIndex, oldIndex }) => {
          const adjust = document.querySelector('.el-table-column--selection');
          if (adjust) {
            newIndex--;
            oldIndex--;
          }
          if (newIndex === oldIndex) {
            setTimeout(() => {
              this.col[oldIndex].width = this.nweWidth;
            }, 300);
            return;
          }
          this.loading = true;
          const oldData = this.col[oldIndex];
          this.col.splice(oldIndex, 1);
          this.col.splice(newIndex, 0, oldData);
          this.$emit('update:parentCol', []);
          this.$nextTick(() => {
            this.$emit('update:parentCol', this.col);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          });
        },
      });
    },
    // 列拖拽
    changeHeaderWidth(newWidth, oldWidth, column, event) {
      this.nweWidth = newWidth;
    },
    clickFn(row) {
      this.$refs.mTable.clearSelection();
      this.$refs.mTable.toggleRowSelection(row);
    },
    dblclickFn(row) {
      this.$refs.mTable.clearSelection();
      this.$refs.mTable.toggleRowSelection(row);
      this.$emit('getDetail');
    },
    toEdit(row, column, cell, event) {
      if (!this.isEdit) return;
      this.unbindKeys();
      this.bindKey();
      const currentDom = $(event.target);
      const className = currentDom.attr('class');
      if (currentDom[0].tagName === 'INPUT'
          || className.indexOf('checkbox') !== -1
      ) return;
      $('.mt-edit tr td').removeClass('cellFocus cellActive');
      $('.mt-edit tr td div').removeClass('cellFocus cellActive');
      if (className.indexOf('el-table') !== -1) {
        currentDom.addClass('cellActive cellFocus');
        currentDom.find('input').focus();
        return false;
      }
      if (className.indexOf('cell') !== -1) {
        currentDom.parent().classList.addClass('cellFocus cellActive');
        return false;
      }
      currentDom.parent().parent().addClass('cellFocus cellActive');
      currentDom.prev().find('input').focus();
    },
    unbindKeys() {
      $(document).unbind('keydown');
    },
    bindKey() {
      $(document).keydown(this.keyEvent);
    },
  },
};
</script>
<style lang="scss">
.mt-edit {
  .auto-input {
    display: none;
  }

  .el-table__body {
    tr {
      &:last-child {
        .cellFocus {
          border-bottom: 2px solid blue !important;
        }
      }
    }
  }

  .cellFocus {
    border: 1px solid blue !important;
  }

  .span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cellActive {
    .auto-input {
      display: block;
    }

    .auto-input + .span {
      display: none;
    }
  }
}
</style>
